import React, { useState, useRef ,useEffect} from 'react';
import { Table, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Customize_Css/AddProductImage.css';
import add from '../Icons/Add.svg';
import deleteicon from '../Icons/delete.svg';
import uploadicon from '../Icons/upload.svg';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import axios from 'axios';
import { toast } from 'react-toastify';
import { prepareUploadFile, getUploadErrorMessage } from '../utils/prepareUploadFile';
import { useNavigate } from 'react-router-dom';
import eyeOpenIcon from '../Images/eye-open.svg';
import eyeClosedIcon from '../Images/eye-closed.svg';


const AddProductsImage = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const AuthorizationToken = localStorage.getItem('token');
  const epicxTenantId = localStorage.getItem('epicxTenantId');

  const navigate = useNavigate();
  const [products, setProducts] = useState([
    {
      id: 1,
      productName: '',
      categoryName: '',
      subCategoryName: '',
      image: '',
      imageCount: '',
      uploadedImages: [],
    },
  ]);
  const [subCategoriesValues, setSubCategoriesValues] = useState({});
  const [imageVisibility, setImageVisibility] = useState({});
  const [submittingCategories, setSubmittingCategories] = useState(false);
  const [submittingSubCategories, setSubmittingSubCategories] = useState(false);
  const [submittingProducts, setSubmittingProducts] = useState(false);
  const handleToggleImageVisibility = (productId) => {
    setImageVisibility((prevState) => ({
      ...prevState,
      [productId]: !prevState[productId], 
    }));
  };
  const [categories, setCategories] = useState([
    {
      id: 1,
      categoryName: '',
      categoryType: '',
      vegOrNonVeg: '',
      image: '',
      imageFile: null,
    },
  ]);
  const [subCategories, setSubCategories] = useState([
    {
      id: 1,
      categoryName: '',
      subCategoryName: '',
      subCategoryType: '',
      vegOrNonVeg: '',
      image: '',
      imageFile: null,
    },
  ]);
  const [categoryName, setCategoryNames] = useState([]);
    useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/products/api/category/${epicxTenantId}`, {
          headers: {
            Authorization: `Bearer ${AuthorizationToken}`,
          },
        });
        setCategoryNames(response.data.categories);
        
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };
  
    fetchCategories();
  }, [BASE_URL, AuthorizationToken, epicxTenantId]);
  
  const productFileInputRefs = useRef([]);
  const categoryFileInputRefs = useRef([]);
  const subCategoryFileInputRefs = useRef([]);

  const handleCategoryImageChange = (id, event) => {
    const file = event.target.files[0];
    const imageUrl = file ? URL.createObjectURL(file) : '';
    
    setCategories((prevCategories) =>
      prevCategories.map((category) => {
        if (category.id === id) {
          return {
            ...category,
            image: imageUrl,
            imageFile: file || null,
            isInvalid: {
              ...category.isInvalid,
              image: !file,
            },
          };
        }
        return category;
      })
    );
  };
  const handleSubCategoryImageChange = (id, event) => {
    const file = event.target.files[0];
    const imageUrl = file ? URL.createObjectURL(file) : '';
  
    setSubCategories((prevSubCategories) =>
      prevSubCategories.map((subCategory) => {
        if (subCategory.id === id) {
          return {
            ...subCategory,
            image: imageUrl,
            imageFile: file || null,
            isInvalid: {
              ...subCategory.isInvalid,
              image: !file,
            },
          };
        }
        return subCategory;
      })
    );
  };
  const handleProductImageChange = (productId, event) => {
    const files = Array.from(event.target.files); 
    const productIndex = products.findIndex((p) => p.id === productId);
  
    if (productIndex !== -1) {
      const product = products[productIndex];
      const allowedImageCount = parseInt(product.imageCount || 0, 10);
  
      if (!allowedImageCount) {
        toast.error("Please enter an image count before uploading images");
        return;
      }
      if (product.uploadedImages?.length + files.length > allowedImageCount) {
        toast.warning(`You can only upload up to ${allowedImageCount} images`);
        return;
      }
      const imageUrls = files.map((file) => URL.createObjectURL(file));
      const uploadedImages = [...(product.uploadedImages || []), ...files];
      const imagesComplete = uploadedImages.length === allowedImageCount;
      const updatedProducts = [...products];
      updatedProducts[productIndex] = {
        ...product,
        uploadedImages,
        previewImages: [...(product.previewImages || []), ...imageUrls],
        isInvalid: product.isInvalid
          ? { ...product.isInvalid, image: !imagesComplete }
          : product.isInvalid,
      };
  
      setProducts(updatedProducts);
    }
  };
  const handleRemoveImage = (productId, imgIndex) => {
    const productIndex = products.findIndex((p) => p.id === productId);
    
    if (productIndex !== -1) {
      const product = products[productIndex];
      const uploadedImages = product.uploadedImages.filter((_, index) => index !== imgIndex);
      const requiredCount = parseInt(product.imageCount || 0, 10);
      const imagesComplete = requiredCount > 0 && uploadedImages.length === requiredCount;
      const updatedProducts = [...products];
      updatedProducts[productIndex] = {
        ...product,
        uploadedImages,
        previewImages: product.previewImages.filter((_, index) => index !== imgIndex),
        isInvalid: product.isInvalid
          ? { ...product.isInvalid, image: !imagesComplete }
          : product.isInvalid,
      };
  
      setProducts(updatedProducts);
    }
  };
  
  const handleCategoryUploadClick = (index) => {
    if (categoryFileInputRefs.current[index]) {
      categoryFileInputRefs.current[index].click();
    }
  };
  const handleSubCategoryUploadClick = (index) => {
    if (subCategoryFileInputRefs.current[index]) {
      subCategoryFileInputRefs.current[index].click();
    }
  };

  const handleProductUploadClick = (index) => {
    if (productFileInputRefs.current[index]) {
      productFileInputRefs.current[index].click();
    }
  };

  const handleAddProduct = () => {
    const newId = products.length ? products[products.length - 1].id + 1 : 1;
    const newProduct = {
      id: newId,
      productName: '',
      categoryName: 'Select a category',
      subCategoryName: 'Select a subcategory',
      image: '',
      isInvalid: {
        productName: true,
        productType: true,
        categoryName: true,
        subCategoryName: true,
        vegOrNonVeg: true,
        image: true,
      },
    };
    setProducts([...products, newProduct]);
  };
  

  const handleAddCategory = () => {
    const newId = categories.length ? categories[categories.length - 1].id + 1 : 1;
    const newCategory = {
      id: newId,
      categoryName: '',
      categoryType: '',
      vegOrNonVeg: '',
      image: '',
      imageFile: null,
      selectedColor: null,
      isInvalid: {
        categoryName: true,
        categoryType: true,
        vegOrNonVeg: true,
        image: true,
        backgroundColor: true,
      },
    };
    setCategories([...categories, newCategory]);
  };
  const handleAddSubCategory = () => {
    const newId = subCategories.length ? subCategories[subCategories.length - 1].id + 1 : 1;
    const newSubCategory = {
      id: newId,
      categoryId: '',
      categoryName: '', 
      subCategoryName: '', 
      subCategoryType: `Type ${String.fromCharCode(65 + newId % 26)}`, 
      vegOrNonVeg: 'Select Veg or Non-Veg', 
      image: '', 
      imageFile: null,
      selectedColor: null, 
      isInvalid: {
        categoryId: true, 
        categoryName: true,
        subCategoryName: true,
        subCategoryType: true,
        vegOrNonVeg: true,
        image: true,
        backgroundColor: true,
      },
    };
    
    setSubCategories([...subCategories, newSubCategory]);
  };
  
  const handleDeleteProduct = (id) => {
    setProducts((prevProducts) => {
        if (prevProducts.length > 1) {
            return prevProducts.filter((product) => product.id !== id);
        } else {
            toast.warn("At least one product is required");
            return prevProducts;
        }
    });
};

const handleDeleteCategory = (id) => {
  setCategories((prevCategories) => {
      if (prevCategories.length > 1) {
          return prevCategories.filter((category) => category.id !== id);
      } else {
          toast.warn("At least one category is required");
          return prevCategories;
      }
  });
};

  const handleDeleteSubCategory = (id) => {
    setSubCategories((prevSubCategories) => {
        if (prevSubCategories.length > 1) {
            return prevSubCategories.filter((subCategory) => subCategory.id !== id);
        } else {
            toast.warn("At least one sub-category is required");
            return prevSubCategories;
        }
    });
};
  const handleFieldChange = (setState, id, field, value) => {
    setState((prevState) =>
      prevState.map((item) => {
        if (item.id === id) {
          const updatedItem = { ...item, [field]: value };
          if (updatedItem.isInvalid) {
            updatedItem.isInvalid = {
              ...item.isInvalid,
              [field]: field === 'selectedColor' ? !value : !value.trim(), 
            };
          }
  
          return updatedItem;
        }
        return item;
      })
    );
  };

  const handleProductFieldChange = async (setState, id, field, value) => {
    setState((prevState) =>
      prevState.map((item) => {
        if (item.id === id) {
          const updatedItem = { ...item, [field]: value };
          if (field === 'categoryName') {
            updatedItem.subCategoryName = '';
          }

          if (updatedItem.isInvalid) {
            const nextInvalid = {
              ...item.isInvalid,
              [field]: !value.trim(),
            };
            if (field === 'categoryName') {
              nextInvalid.subCategoryName = false;
            }
            if (field === 'imageCount') {
              const requiredCount = parseInt(value || 0, 10);
              const uploadedCount = (item.uploadedImages || []).length;
              nextInvalid.imageCount = !(requiredCount > 0);
              nextInvalid.image = !(requiredCount > 0 && uploadedCount === requiredCount);
            }
            updatedItem.isInvalid = nextInvalid;
          }
  
          return updatedItem;
        }
        return item;
      })
    );
  
    if (field === 'categoryName') {
      const category = categoryName.find((cat) => cat.categoryName === value);
      setSubCategoriesValues((prev) => ({ ...prev, [id]: [] }));
  
      if (category?._id) {
        try {
          const response = await axios.get(`${BASE_URL}/products/api/sub-category/${epicxTenantId}/subCategoryNames/${category._id}`,
            {
              headers: {
                  Authorization: `Bearer ${AuthorizationToken}`,
                },
              }
          );
          if (response.data.length > 0) {
            setSubCategoriesValues((prev) => ({
              ...prev,
              [id]: response.data,
            }));
          } else {
            console.warn('No subcategories found for this category.');
          }
        } catch (error) {
          console.error('Error fetching subcategories values:', error);
        }
      } else {
        console.warn('Category ID not found or invalid.');
      }
    }
  };
  
  const validateCategoryForm = () => {
    let valid = true;
    const updatedCategories = categories.map((category) => {
      const isCategoryNameInvalid = !category.categoryName.trim();
      const isCategoryTypeInvalid = !category.categoryType.trim();
      const isVegOrNonVegInvalid = !category.vegOrNonVeg.trim();
      const isBackgroundColorInvalid = !category.selectedColor; 
      const isImageInvalid = !category.imageFile && !category.image;
  
      const isInvalid = {
        categoryName: isCategoryNameInvalid,
        categoryType: isCategoryTypeInvalid,
        vegOrNonVeg: isVegOrNonVegInvalid,
        backgroundColor: isBackgroundColorInvalid,
        image: isImageInvalid,
      };
  
      valid = valid && !Object.values(isInvalid).some((fieldInvalid) => fieldInvalid);
  
      return { ...category, isInvalid };
    });
  
    setCategories(updatedCategories);
    return valid;
  };
  const isLiveUploadBlocked = (error) =>
    error?.response?.status === 413 ||
    (!error?.response && (error?.message === 'Network Error' || error?.code === 'ERR_NETWORK'));

  const postImageForm = async (url, fieldName, uploadFile, appendFields) => {
    const liveApi = BASE_URL && !String(BASE_URL).includes('localhost');
    const limits = liveApi ? [900 * 1024, 180 * 1024, 50 * 1024] : [null];
    let lastError = null;
    let lastSentSize = Infinity;

    for (const maxImageBytes of limits) {
      const formData = new FormData();
      appendFields(formData);
      if (uploadFile) {
        const prepared = await prepareUploadFile(
          uploadFile,
          maxImageBytes ? { maxImageBytes } : undefined
        );
        if (prepared && prepared.size >= lastSentSize) {
          continue;
        }
        lastSentSize = prepared?.size || 0;
        formData.append(fieldName, prepared);
      }
      try {
        return await axios.post(url, formData, {
          headers: {
            Authorization: `Bearer ${AuthorizationToken}`,
          },
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
        });
      } catch (error) {
        lastError = error;
        if (!liveApi || !isLiveUploadBlocked(error)) {
          throw error;
        }
      }
    }
    throw lastError;
  };

  const postCategoryForm = async (category) => {
    const fileInputIndex = categories.findIndex((c) => c.id === category.id);
    const uploadFile =
      category.imageFile || categoryFileInputRefs.current[fileInputIndex]?.files?.[0];

    return postImageForm(
      `${BASE_URL}/products/api/category/${epicxTenantId}`,
      'categoryImage',
      uploadFile,
      (formData) => {
        formData.append('categoryName', category.categoryName);
        formData.append('categoryType', category.categoryType);
        formData.append('vegOrNonVeg', category.vegOrNonVeg);
        formData.append(
          'backgroundColor',
          category.selectedColor
            ? `${category.selectedColor.name},${category.selectedColor.code}`
            : ''
        );
      }
    );
  };

  const submitCategories = async () => {
    if (submittingCategories) return;
    if (!validateCategoryForm()) {
      toast.error('Please fill in all required fields');
      return;
    }

    setSubmittingCategories(true);
    try {
    let savedCount = 0;
    const failedNames = [];
    let lastError = null;

    for (const category of categories) {
      try {
        await postCategoryForm(category);
        savedCount += 1;
      } catch (error) {
        lastError = error;
        console.error('Error submitting category:', category.categoryName, error);
        failedNames.push(category.categoryName || 'Unnamed category');
      }
    }

    if (savedCount === categories.length) {
      toast.success('Categories submitted successfully!');
      setCategories([
        {
          id: 1,
          categoryName: '',
          categoryType: '',
          vegOrNonVeg: '',
          selectedColor: null,
          image: null,
          imageFile: null,
        },
      ]);
      categoryFileInputRefs.current = [];
      return;
    }

    if (savedCount > 0) {
      toast.warn(
        `${savedCount} of ${categories.length} categories saved. Failed: ${failedNames.join(', ')}`
      );
      return;
    }

    toast.error(
      getUploadErrorMessage(
        lastError,
        `Failed to submit categories: ${failedNames.join(', ')}`
      )
    );
    } finally {
      setSubmittingCategories(false);
    }
  };
  const validateSubCategories = () => {
    let valid = true;
  
    const updatedSubCategories = subCategories.map((subCategory) => {
      const isCategoryIdInvalid = !subCategory.categoryId?.trim(); 
      const isSubCategoryNameInvalid = !subCategory.subCategoryName.trim();
      const isBackgroundColorInvalid = !subCategory.selectedColor; 
      const isImageInvalid = !subCategory.imageFile && !subCategory.image;
     
      const isInvalid = {
        categoryName: isCategoryIdInvalid,
        subCategoryName: isSubCategoryNameInvalid,
        backgroundColor: isBackgroundColorInvalid,
        image: isImageInvalid,
      };
      valid = valid && !Object.values(isInvalid).some((fieldInvalid) => fieldInvalid);
  
      return { ...subCategory, isInvalid };
    });
    setSubCategories(updatedSubCategories);
    return valid;
  };

  const postSubCategoryForm = async (subCategory) => {
    const fileInputIndex = subCategories.findIndex((item) => item.id === subCategory.id);
    const uploadFile =
      subCategory.imageFile || subCategoryFileInputRefs.current[fileInputIndex]?.files?.[0];

    return postImageForm(
      `${BASE_URL}/products/api/sub-category/${epicxTenantId}`,
      'subcategoryImage',
      uploadFile,
      (formData) => {
        formData.append('categoryName', subCategory.categoryName || '');
        formData.append('categoryId', subCategory.categoryId || '');
        formData.append('subCategoryName', subCategory.subCategoryName || '');
        formData.append(
          'backgroundColor',
          subCategory.selectedColor
            ? `${subCategory.selectedColor.name},${subCategory.selectedColor.code}`
            : ''
        );
      }
    );
  };
  
  const submitSubCategories = async () => {
    if (submittingSubCategories) return;
    if (!validateSubCategories()) {
      toast.error('Please fill all required fields');
      return;
    }

    setSubmittingSubCategories(true);
    try {
    let savedCount = 0;
    const failedNames = [];
    let lastError = null;

    for (const subCategory of subCategories) {
      try {
        await postSubCategoryForm(subCategory);
        savedCount += 1;
      } catch (error) {
        lastError = error;
        console.error('Error submitting sub category:', subCategory.subCategoryName, error);
        failedNames.push(subCategory.subCategoryName || 'Unnamed sub category');
      }
    }

    if (savedCount === subCategories.length) {
      toast.success('Sub Categories submitted successfully');
      setSubCategories([
        {
          id: 1,
          categoryName: '',
          categoryId: '',
          subCategoryName: '',
          image: null,
          imageFile: null,
        },
      ]);
      subCategoryFileInputRefs.current = [];
      return;
    }

    if (savedCount > 0) {
      toast.warn(
        `${savedCount} of ${subCategories.length} sub categories saved. Failed: ${failedNames.join(', ')}`
      );
      return;
    }

    toast.error(
      getUploadErrorMessage(
        lastError,
        `Failed to submit sub categories: ${failedNames.join(', ')}`
      )
    );
    } finally {
      setSubmittingSubCategories(false);
    }
  };
  
  const validateProductForm = () => {
    let valid = true;
    const updatedProducts = products.map((product) => {
      const isProductNameInvalid = !product.productName;
      const isCategoryNameInvalid = !product.categoryName|| product.categoryName === 'Select a category';
      const subCategoryList = subCategoriesValues[product.id];
      const subCategoryRequired = Array.isArray(subCategoryList) && subCategoryList.length > 0;
      const subCategoryChosen = Boolean(product.subCategoryName) && product.subCategoryName !== 'Select a subcategory';
      const requiredImageCount = parseInt(product.imageCount || 0, 10);
      const uploadedImageCount = (product.uploadedImages || []).length;
      const isImageCountInvalid = !(requiredImageCount > 0);
      const isImageInvalid = !(requiredImageCount > 0 && uploadedImageCount === requiredImageCount);

      const isInvalid = {
        productName: isProductNameInvalid,
        categoryName: isCategoryNameInvalid,
        subCategoryName: subCategoryRequired && !subCategoryChosen,
        imageCount: isImageCountInvalid,
        image: isImageInvalid,
      };
  
      valid = valid && !Object.values(isInvalid).some((fieldInvalid) => fieldInvalid);
  
      return { ...product, isInvalid };
    });
  
    setProducts(updatedProducts);
    return valid;
  };

const postOneProduct = async (product) => {
  const liveApi = BASE_URL && !String(BASE_URL).includes('localhost');
  const limits = liveApi ? [900 * 1024, 180 * 1024, 50 * 1024] : [null];
  let lastError = null;
  let lastSentSize = Infinity;

  for (const maxImageBytes of limits) {
    const formData = new FormData();
    formData.append(
      'products',
      JSON.stringify([
        {
          productName: product.productName,
          categoryName: product.categoryName,
          subCategoryName: product.subCategoryName || '',
          imageCount: product.imageCount,
        },
      ])
    );

    let totalSize = 0;
    const images = product.uploadedImages || [];
    for (let imgIndex = 0; imgIndex < images.length; imgIndex += 1) {
      const prepared = await prepareUploadFile(
        images[imgIndex],
        maxImageBytes ? { maxImageBytes } : undefined
      );
      totalSize += prepared?.size || 0;
      formData.append(`productImage_0_${imgIndex}`, prepared);
    }

    if (totalSize > 0 && totalSize >= lastSentSize) {
      continue;
    }
    lastSentSize = totalSize || lastSentSize;

    try {
      return await axios.post(
        `${BASE_URL}/products/api/products/${epicxTenantId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${AuthorizationToken}`,
          },
          maxContentLength: Infinity,
          maxBodyLength: Infinity,
        }
      );
    } catch (error) {
      lastError = error;
      if (!liveApi || !isLiveUploadBlocked(error)) {
        throw error;
      }
    }
  }

  throw lastError;
};

const submitProducts = async () => {
  if (submittingProducts) return;
  if (!validateProductForm()) {
    toast.error('Please fill in all required fields');
    return;
  }

  setSubmittingProducts(true);
  try {
  let savedCount = 0;
  const failedNames = [];
  let lastError = null;

  for (const product of products) {
    try {
      await postOneProduct(product);
      savedCount += 1;
    } catch (error) {
      lastError = error;
      console.error('Error submitting product:', product.productName, error);
      failedNames.push(product.productName || 'Unnamed product');
    }
  }

  if (savedCount === products.length) {
    toast.success('Products submitted successfully');
    setProducts([
      {
        id: 1,
        productName: '',
        categoryName: '',
        subCategoryName: '',
      },
    ]);
    productFileInputRefs.current = [];
    return;
  }

  if (savedCount > 0) {
    toast.warn(
      `${savedCount} of ${products.length} products saved. Failed: ${failedNames.join(', ')}`
    );
    return;
  }

  toast.error(getUploadErrorMessage(lastError, 'Failed to submit products. Please try again.'));
  } finally {
    setSubmittingProducts(false);
  }
};

const colors = [
  { name: 'Mint Green', code: '#D1F6DE' },
  { name: 'Peach Orange', code: '#FBE2C6' },
  { name: 'Light Salmon', code: '#FDDCD5' },
  { name: 'Lavender', code: '#EFD5F7' },
  { name: 'Pale Yellow', code: '#F4E9C8' },
  { name: 'Light Sky Blue', code: '#EDF7FC' },
];

const handleColorSelect = (id, color) => {
  setCategories((prevCategories) =>
    prevCategories.map((category) => {
      if (category.id === id) {
        return {
          ...category,
          selectedColor: color,
          isInvalid: {
            ...category.isInvalid,
            backgroundColor: !color, 
          },
        };
      }
      return category;
    })
  );
};
const handleColorSelectSubCategories = (subCategoryId, color) => {
  setSubCategories((prevSubCategories) =>
    prevSubCategories.map((subCategory) => {
      if (subCategory.id === subCategoryId) {
        return {
          ...subCategory,
          selectedColor: color,
          isInvalid: {
            ...subCategory.isInvalid,
            backgroundColor: !color, 
          },
        };
      }
      return subCategory;
    })
  );
};

  const renderColorPicker = (selectedColor, invalid, onSelect) => (
    <div className={`color-picker ${invalid ? 'is-invalid' : ''}`}>
      {colors.map((color) => (
        <button
          type="button"
          key={color.code}
          className={`color-swatch ${selectedColor?.code === color.code ? 'is-selected' : ''}`}
          style={{ backgroundColor: color.code }}
          title={color.name}
          aria-label={color.name}
          onClick={() => onSelect(color)}
        />
      ))}
      <span className="color-picker-label">
        {selectedColor ? selectedColor.name : 'Select a color'}
      </span>
    </div>
  );

  return (
    <>
      <Sidebar />
      <div className="add-image-page">
        <header className="add-image-hero">
          <div>
            <p className="add-image-kicker">Inventory</p>
            <h1>Add Image Details</h1>
            <p>Add categories first, then sub categories, then products. Each section saves on its own, so you can fill one step and come back to the others.</p>
          </div>
          <div className="step-pills">
            <button type="button" className="step-pill" onClick={() => document.getElementById('image-step-categories')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}>1 · Categories</button>
            <button type="button" className="step-pill" onClick={() => document.getElementById('image-step-subcategories')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}>2 · Sub categories</button>
            <button type="button" className="step-pill" onClick={() => document.getElementById('image-step-products')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}>3 · Products</button>
          </div>
        </header>

        <section className="add-image-card" id="image-step-categories">
          <div className="add-image-card-head">
            <span className="step-badge">1</span>
            <div>
              <h2>Add Categories</h2>
              <p>Name, type, diet, image, and a background color for each category.</p>
            </div>
          </div>
          <div className="table-wrap">
            <Table className="table-custom add-image-table">
              <thead>
                <tr>
                  <th>Category Name <span className="req">*</span></th>
                  <th>Category Type <span className="req">*</span></th>
                  <th>Veg/Non-Veg <span className="req">*</span></th>
                  <th>Category Image <span className="req">*</span></th>
                  <th>Background Color <span className="req">*</span></th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {categories.map((category, index) => (
                  <tr key={category.id}>
                    <td>
                      <Form.Control
                        type="text"
                        value={category.categoryName}
                        placeholder='Category Name'
                        onChange={(e) => handleFieldChange(setCategories, category.id, 'categoryName', e.target.value)}
                        className={`bg-light ${category.isInvalid?.categoryName ? 'border-danger' : ''}`}
                      />
                    </td>
                    <td>
                      <Form.Control
                        as="select"
                        value={category.categoryType}
                        onChange={(e) => handleFieldChange(setCategories, category.id, 'categoryType', e.target.value)}
                        className={`bg-light ${category.isInvalid?.categoryType ? 'border-danger' : ''}`}
                      >
                        <option value=" ">Select Category Type</option>
                        <option value="Perishable">Perishable</option>
                        <option value="Non-Perishable">Non-Perishable</option>
                      </Form.Control>
                    </td>
                    <td>
                      <Form.Control
                        as="select"
                        value={category.vegOrNonVeg}
                        onChange={(e) => handleFieldChange(setCategories, category.id, 'vegOrNonVeg', e.target.value)}
                        className={`bg-light ${category.isInvalid?.vegOrNonVeg ? 'border-danger' : ''}`}
                      >
                        <option value=" ">Select Type</option>
                        <option value="Veg">Veg</option>
                        <option value="Non-Veg">Non-Veg</option>
                      </Form.Control>
                    </td>
                    <td>
                      <div className="upload-field">
                        <button
                          type="button"
                          onClick={() => handleCategoryUploadClick(index)}
                          className={`upload-chip ${category.isInvalid?.image ? 'is-invalid' : ''}`}
                        >
                          {category.image ? 'Change' : 'Upload'}
                          <img src={uploadicon} alt="" />
                        </button>
                        <Form.Control
                          type="file"
                          accept="image/*"
                          ref={(el) => (categoryFileInputRefs.current[index] = el)}
                          style={{ display: 'none' }}
                           onChange={(e) => handleCategoryImageChange(categories[index].id, e)}
                        />
                        {category.image && (
                          <img
                            src={category.image}
                            alt="Uploaded category"
                            className="upload-thumb"
                          />
                        )}
                      </div>
                    </td>
                    <td>
                      {renderColorPicker(
                        category.selectedColor,
                        category.isInvalid?.backgroundColor,
                        (color) => handleColorSelect(category.id, color)
                      )}
                    </td>
                    <td>
                      <div className="row-actions">
                        <button
                          type="button"
                          onClick={() => handleDeleteCategory(category.id)}
                          className="icon-btn icon-btn-delete"
                          title="Remove this category"
                        >
                          <img src={deleteicon} alt="Delete" />
                        </button>
                        <button
                          type="button"
                          onClick={handleAddCategory}
                          className="icon-btn icon-btn-add"
                          title="Add another category"
                        >
                          <img src={add} alt="Add" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className="add-image-actions">
            <Button onClick={submitCategories} className="api-btn api-btn-primary" disabled={submittingCategories}>
              {submittingCategories ? 'Submitting...' : 'Submit Categories Image'}
            </Button>
            <Button
              onClick={() => navigate('/viewCategoryImage')}
              className="api-btn api-btn-secondary"
            >
              View Categories Image
            </Button>
          </div>
        </section>

        <section className="add-image-card" id="image-step-subcategories">
          <div className="add-image-card-head">
            <span className="step-badge">2</span>
            <div>
              <h2>Add Sub Categories</h2>
              <p>Choose a saved category, then add the sub category name, image, and color.</p>
            </div>
          </div>
          <div className="table-wrap">
            <Table className="table-custom add-image-table">
              <thead>
                <tr>
                  <th>Category Name <span className="req">*</span></th>
                  <th>Sub Category Name <span className="req">*</span></th>
                  <th>Sub Category Image <span className="req">*</span></th>
                  <th>Background Color <span className="req">*</span></th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {subCategories.map((subCategory, index) => (
                  <tr key={subCategory.id}>
                    <td>
                    <Form.Control
                    as="select"
                    value={subCategory.categoryId}  
                    onChange={(e) => {
                      const selectedCategoryId = e.target.value;
                      const selectedCategory = categoryName.find(category => category._id === selectedCategoryId);
                      handleProductFieldChange(setSubCategories, subCategory.id, 'categoryName', selectedCategory.categoryName);
                      handleProductFieldChange(setSubCategories, subCategory.id, 'categoryId', selectedCategory._id);  
                    }}
                    className={`bg-light ${subCategory.isInvalid?.categoryName ? 'border-danger' : ''}`}
                  >
                    <option value="">Select a category</option>
                    {categoryName.map((category) => (
                      <option key={category._id} value={category._id}>
                        {category.categoryName} 
                      </option>
                    ))}
                  </Form.Control>
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        value={subCategory.subCategoryName}
                        placeholder='Sub Category Name'
                        onChange={(e) => handleFieldChange(setSubCategories, subCategory.id, 'subCategoryName', e.target.value)}
                        className={`bg-light ${subCategory.isInvalid?.subCategoryName ? 'border-danger' : ''}`}
                      />
                    </td>
                    <td>
                      <div className="upload-field">
                        <button
                          type="button"
                          onClick={() => handleSubCategoryUploadClick(index)}
                          className={`upload-chip ${subCategory.isInvalid?.image ? 'is-invalid' : ''}`}
                        >
                          {subCategory.image ? 'Change' : 'Upload'}
                          <img src={uploadicon} alt="" />
                        </button>
                        <Form.Control
                          type="file"
                          accept="image/*"
                          ref={(el) => (subCategoryFileInputRefs.current[index] = el)}
                          style={{ display: 'none' }}
                          onChange={(e) => handleSubCategoryImageChange(subCategories[index].id, e)}
                        />
                        {subCategory.image && (
                          <img
                            src={subCategory.image}
                            alt="Uploaded sub category"
                            className="upload-thumb"
                          />
                        )}
                      </div>
                    </td>
                    <td>
                      {renderColorPicker(
                        subCategory.selectedColor,
                        subCategory.isInvalid?.backgroundColor,
                        (color) => handleColorSelectSubCategories(subCategory.id, color)
                      )}
                    </td>
                    <td>
                      <div className="row-actions">
                        <button
                          type="button"
                          onClick={() => handleDeleteSubCategory(subCategory.id)}
                          className="icon-btn icon-btn-delete"
                          title="Remove this sub category"
                        >
                          <img src={deleteicon} alt="Delete" />
                        </button>
                        <button
                          type="button"
                          onClick={handleAddSubCategory}
                          className="icon-btn icon-btn-add"
                          title="Add another sub category"
                        >
                          <img src={add} alt="Add" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className="add-image-actions">
            <Button onClick={submitSubCategories} className="api-btn api-btn-primary" disabled={submittingSubCategories}>
              {submittingSubCategories ? 'Submitting...' : 'Submit Sub Categories Image'}
            </Button>
            <Button onClick={() => navigate('/viewSubCategoryImage')} className="api-btn api-btn-secondary">View Sub Categories Image</Button>
          </div>
        </section>

        <section className="add-image-card" id="image-step-products">
          <div className="add-image-card-head">
            <span className="step-badge">3</span>
            <div>
              <h2>Add Products</h2>
              <p>Pick a category to load its sub categories, set the image count, then upload that many photos.</p>
            </div>
          </div>
          <div className="table-wrap">
            <Table className="table-custom add-image-table products-table">
              <thead>
                <tr>
                  <th>Product Name <span className="req">*</span></th>
                  <th>Category Name <span className="req">*</span></th>
                  <th>Sub Category Name</th>
                  <th>Image Count <span className="req">*</span></th>
                  <th>Product Image <span className="req">*</span></th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product, index) => {
                  const categorySelected = Boolean(product.categoryName) && product.categoryName !== 'Select a category';
                  const subCategoryList = subCategoriesValues[product.id];
                  const noSubCategories = categorySelected && Array.isArray(subCategoryList) && subCategoryList.length === 0;
                  const subCategoryRequired = Array.isArray(subCategoryList) && subCategoryList.length > 0;
                  const subCategoryChosen = Boolean(product.subCategoryName) && product.subCategoryName !== 'Select a subcategory';
                  const subCategoryMissing = subCategoryRequired && !subCategoryChosen;
                  const requiredImageCount = parseInt(product.imageCount || 0, 10);
                  const uploadedImageCount = (product.uploadedImages || []).length;
                  const imagesComplete = requiredImageCount > 0 && uploadedImageCount === requiredImageCount;
                  return (
                  <React.Fragment key={product.id}>
                    <tr>
                      <td>
                        <Form.Control
                          type="text"
                          value={product.productName}
                          placeholder="Product Name"
                          onChange={(e) =>
                            handleProductFieldChange(setProducts, product.id, 'productName', e.target.value)
                          }
                          className={`bg-light ${product.isInvalid?.productName ? 'border-danger' : ''}`}
                        />
                      </td>
                      <td>
                        <Form.Control
                          as="select"
                          value={product.categoryName}
                          onChange={(e) =>
                            handleProductFieldChange(setProducts, product.id, 'categoryName', e.target.value)
                          }
                          className={`bg-light ${product.isInvalid?.categoryName ? 'border-danger' : ''}`}
                        >
                          <option value="">Select a category</option>
                          {categoryName.map((category) => (
                            <option key={category._id} value={category.categoryName}>
                              {category.categoryName}
                            </option>
                          ))}
                        </Form.Control>
                      </td>
                      <td>
                        <Form.Control
                          as="select"
                          value={product.subCategoryName}
                          onChange={(e) =>
                            handleProductFieldChange(setProducts, product.id, 'subCategoryName', e.target.value)
                          }
                          className={`bg-light ${noSubCategories ? 'is-complete' : subCategoryMissing ? 'border-danger' : ''}`}
                          disabled={!subCategoryList || subCategoryList.length === 0}
                        >
                          <option value="">Select a subcategory</option>
                          {Array.isArray(subCategoriesValues[product.id]) &&
                          subCategoriesValues[product.id].length > 0 ? (
                            subCategoriesValues[product.id].map((subCategory) => (
                              <option key={subCategory._id} value={subCategory.subCategoryName}>
                                {subCategory.subCategoryName}
                              </option>
                            ))
                          ) : (
                            <option disabled>No subcategories available</option>
                          )}
                        </Form.Control>
                      </td>
                      <td>
                        <Form.Control
                          type="number"
                          value={product.imageCount || ''}
                          placeholder="Image Count"
                          min="1"
                          onChange={(e) =>
                            handleProductFieldChange(setProducts, product.id, 'imageCount', e.target.value)
                          }
                          className={`bg-light ${product.isInvalid?.imageCount ? 'border-danger' : ''}`}
                        />
                      </td>
                      <td>
                        <div className="upload-meta">
                          <button
                            type="button"
                            onClick={() => handleProductUploadClick(index)}
                            className={`upload-chip ${imagesComplete ? 'is-complete' : product.isInvalid?.image ? 'is-invalid' : ''}`}
                          >
                            Upload
                            <img src={uploadicon} alt="" />
                          </button>
                          <Form.Control
                            type="file"
                            accept="image/*"
                            multiple
                            ref={(el) => (productFileInputRefs.current[index] = el)}
                            style={{ display: 'none' }}
                            onChange={(e) => handleProductImageChange(product.id, e)}
                          />
                          <span className="upload-count">
                            {(product.uploadedImages || []).length}
                            {product.imageCount ? ` / ${product.imageCount}` : ''} uploaded
                          </span>
                        </div>
                      </td>
                      <td>
                        <div className="row-actions">
                          <button
                            type="button"
                            onClick={() => handleDeleteProduct(product.id)}
                            className="icon-btn icon-btn-delete"
                            title="Remove this product"
                          >
                            <img src={deleteicon} alt="Delete" />
                          </button>
                          <button
                            type="button"
                            onClick={handleAddProduct}
                            className="icon-btn icon-btn-add"
                            title="Add another product"
                          >
                            <img src={add} alt="Add" />
                          </button>
                          <button
                            type="button"
                            onClick={() => handleToggleImageVisibility(product.id)}
                            className={`icon-btn icon-btn-eye ${imageVisibility[product.id] ? 'is-on' : ''}`}
                            title={imageVisibility[product.id] ? 'Hide images' : 'Show images'}
                          >
                            <img
                              src={imageVisibility[product.id] ? eyeOpenIcon : eyeClosedIcon}
                              alt="Toggle images"
                            />
                          </button>
                        </div>
                      </td>
                    </tr>
                    {imageVisibility[product.id] && (
                      <tr key={`images-${product.id}`} className="preview-row">
                        <td colSpan={8}>
                          <div className="preview-strip">
                            {product.previewImages?.length ? (
                              product.previewImages.map((image, imgIndex) => (
                                <div key={imgIndex} className="preview-item">
                                  <img src={image} alt={`Uploaded ${imgIndex + 1}`} />
                                  <button
                                    type="button"
                                    className="preview-remove"
                                    onClick={() => handleRemoveImage(product.id, imgIndex)}
                                    title="Remove image"
                                  >
                                    ✕
                                  </button>
                                </div>
                              ))
                            ) : (
                              <span className="preview-empty">No images uploaded yet. Set the image count, then upload.</span>
                            )}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                  );
                })}
              </tbody>
            </Table>
          </div>
          <div className="add-image-actions">
            <Button onClick={submitProducts} className="api-btn api-btn-primary" disabled={submittingProducts}>
              {submittingProducts ? 'Submitting...' : 'Submit Products Image'}
            </Button>
            <Button
              onClick={() => navigate('/viewProductImage')}
              className="api-btn api-btn-secondary"
            >
              View Products Image
            </Button>
          </div>
        </section>
      <Footer />
      </div>
    </>
  );
};

export default AddProductsImage;
